// import React, { useState } from "react";

// const QuizCard = ({ data, classes, onSkip }) => {
//   const [selected, setSelected] = useState(null);
//   const [submitted, setSubmitted] = useState(false);

//   if (
//     !data ||
//     typeof data.question !== "string" ||
//     !Array.isArray(data.options) ||
//     typeof data.answer !== "number" ||
//     data.answer < 0 ||
//     data.answer >= data.options.length
//   ) {
//     return (
//       <div className={classes.card}>
//         <h3>⚠️ Invalid quiz data</h3>
//       </div>
//     );
//   }

//   const handleOptionClick = (index) => {
//     if (submitted) return;
//     setSelected(index);
//     setSubmitted(true);
//   };

//   return (
//     <div className={`${classes.card} quiz-card`}>
//       <h3>{data.question}</h3>
//       <ul style={{ listStyle: "none", padding: 0 }}>
//         {data.options.map((opt, idx) => (
//           <li
//             key={idx}
//             onClick={() => handleOptionClick(idx)}
//             style={{
//               cursor: submitted ? "not-allowed" : "pointer",
//               backgroundColor:
//                 submitted && idx === data.answer
//                   ? "#c8e6c9"
//                   : submitted && idx === selected
//                   ? "#ffcdd2"
//                   : "#f5f5f5",
//               padding: "10px",
//               margin: "5px 0",
//               borderRadius: "5px",
//               border: "1px solid #ccc",
//             }}
//           >
//             {opt}
//           </li>
//         ))}
//       </ul>
//       {submitted && (
//         <p style={{ fontWeight: "bold" }}>
//           {selected === data.answer ? "✅ Correct!" : "❌ Incorrect!"} Correct
//           Answer:{" "}
//           <span style={{ color: "#2196f3" }}>{data.options[data.answer]}</span>
//         </p>
//       )}

//       {!submitted && (
//         <button
//           style={{
//             marginTop: "12px",
//             padding: "10px 20px",
//             borderRadius: "8px",
//             background: "linear-gradient(135deg, #ff4081, #ff80ab)",
//             border: "none",
//             color: "#fff",
//             fontWeight: "bold",
//             fontSize: "14px",
//             cursor: "pointer",
//             transition: "transform 0.2s ease, box-shadow 0.2s ease",
//             boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
//           }}
//           onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
//           onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
//           onClick={onSkip}
//         >
//           🚫 Skip All Quizzes
//         </button>
//       )}
//     </div>
//   );
// };

// export default QuizCard;

// import React, { useState, useEffect } from "react";

// const QuizCard = ({ data, classes, onSkip, nextRef }) => {
//   const [selected, setSelected] = useState(null);
//   const [submitted, setSubmitted] = useState(false);

//   if (
//     !data ||
//     typeof data.question !== "string" ||
//     !Array.isArray(data.options) ||
//     typeof data.answer !== "number" ||
//     data.answer < 0 ||
//     data.answer >= data.options.length
//   ) {
//     return (
//       <div className={classes.card}>
//         <h3>⚠️ Invalid quiz data</h3>
//       </div>
//     );
//   }

//   const handleOptionClick = (index) => {
//     if (submitted) return;
//     setSelected(index);
//     setSubmitted(true);

//     // Scroll to next card after short delay
//     setTimeout(() => {
//       // nextRef?.current?.scrollIntoView({ behavior: "smooth", block: "start" });
//       if (nextRef?.current) {
//   const topOffset = nextRef.current.getBoundingClientRect().top + window.pageYOffset - 80; // adjust 80 as per your fixed header height
//   window.scrollTo({ top: topOffset, behavior: "smooth" });
// }

//     }, 1000);
//   };

//   return (
//     <div className={`${classes.card} quiz-card`}>
//       <h3>{data.question}</h3>
//       <ul style={{ listStyle: "none", padding: 0 }}>
//         {data.options.map((opt, idx) => (
//           <li
//             key={idx}
//             onClick={() => handleOptionClick(idx)}
//             style={{
//               cursor: submitted ? "not-allowed" : "pointer",
//               backgroundColor:
//                 submitted && idx === data.answer
//                   ? "#c8e6c9"
//                   : submitted && idx === selected
//                   ? "#ffcdd2"
//                   : "#f5f5f5",
//               padding: "10px",
//               margin: "5px 0",
//               borderRadius: "5px",
//               border: "1px solid #ccc",
//             }}
//           >
//             {opt}
//           </li>
//         ))}
//       </ul>
//       {submitted && (
//         <p style={{ fontWeight: "bold" }}>
//           {selected === data.answer ? "✅ Correct!" : "❌ Incorrect!"} Correct
//           Answer:{" "}
//           <span style={{ color: "#2196f3" }}>{data.options[data.answer]}</span>
//         </p>
//       )}

//       {!submitted && (
//         <button
//           style={{
//             marginTop: "12px",
//             padding: "10px 20px",
//             borderRadius: "8px",
//             background: "linear-gradient(135deg, #ff4081, #ff80ab)",
//             border: "none",
//             color: "#fff",
//             fontWeight: "bold",
//             fontSize: "14px",
//             cursor: "pointer",
//             transition: "transform 0.2s ease, box-shadow 0.2s ease",
//             boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
//           }}
//           onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
//           onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
//           onClick={onSkip}
//         >
//           🚫 Skip All Quizzes
//         </button>
//       )}
//     </div>
//   );
// };

// export default QuizCard;

import React, { useState } from "react";

const QuizCard = ({ data, classes, onSkip, nextRef, containerRef }) => {
  const [selected, setSelected] = useState(null);
  const [submitted, setSubmitted] = useState(false);

  if (
    !data ||
    typeof data.question !== "string" ||
    !Array.isArray(data.options) ||
    typeof data.answer !== "number" ||
    data.answer < 0 ||
    data.answer >= data.options.length
  ) {
    return (
      <div className={classes.card}>
        <h3>⚠️ Invalid quiz data</h3>
      </div>
    );
  }

  const handleOptionClick = (index) => {
    if (submitted) return;
    setSelected(index);
    setSubmitted(true);

    // Scroll to next item inside the feed container
    setTimeout(() => {
      if (nextRef?.current && containerRef?.current) {
        const offsetTop =
          nextRef.current.offsetTop -
          containerRef.current.offsetTop -
          80; // Adjust 80 if your fixed header is taller/shorter
        containerRef.current.scrollTo({
          top: offsetTop,
          behavior: "smooth",
        });
      }
    }, 1000);
  };

  return (
    <div className={`${classes.card} quiz-card`}>
      <h3>{data.question}</h3>
      <ul style={{ listStyle: "none", padding: 0 }}>
        {data.options.map((opt, idx) => (
          <li
            key={idx}
            onClick={() => handleOptionClick(idx)}
            style={{
              cursor: submitted ? "not-allowed" : "pointer",
              backgroundColor:
                submitted && idx === data.answer
                  ? "#c8e6c9"
                  : submitted && idx === selected
                  ? "#ffcdd2"
                  : "#f5f5f5",
              padding: "10px",
              margin: "5px 0",
              borderRadius: "5px",
              border: "1px solid #ccc",
            }}
          >
            {opt}
          </li>
        ))}
      </ul>
      {submitted && (
        <p style={{ fontWeight: "bold" }}>
          {selected === data.answer ? "✅ Correct!" : "❌ Incorrect!"} Correct
          Answer:{" "}
          <span style={{ color: "#2196f3" }}>{data.options[data.answer]}</span>
        </p>
      )}

      {!submitted && (
        <button
          style={{
            marginTop: "12px",
            padding: "10px 20px",
            borderRadius: "8px",
            background: "linear-gradient(135deg, #ff4081, #ff80ab)",
            border: "none",
            color: "#fff",
            fontWeight: "bold",
            fontSize: "14px",
            cursor: "pointer",
            transition: "transform 0.2s ease, box-shadow 0.2s ease",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          }}
          onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
          onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
          onClick={onSkip}
        >
          🚫 Skip All Quizzes
        </button>
      )}
    </div>
  );
};

export default QuizCard;
